module.exports = __webpack_public_path__ + "static/media/platziconf-logo.a1880fbf.svg";